import { useTheme } from '@emotion/react'
import React, { useState } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import Modal from '../../../common/modal'
import LineinputV2 from '../../../common/lineinputV2'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useDispatch } from 'react-redux'
import { getKgKmRateFileUploadCancel } from '../../../../store/generalSetting/GSAction'
import { updateAlertError } from '../../../../store/common/common_action'

const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
const KgKmCancelPop = ({data, methods}) => {
    const dispatch = useDispatch()
    const { loginData, headText, cancelData, setMsg, setIsSuccess, getUploadTblData, fileData } = data
    const { updateModal } = methods
    const [remarks, setRemarks] = useState('')
    const theme = useTheme()
    const handleSave = () => {
        if (remarks?.length === 0) {
            dispatch(updateAlertError({show: true, msg: 'Please Enter Reason For Cancellation Of Kg - Km Rates',success: false, nextId: `chooseFileInput` }))
        }else{
            let body = {
                CompanyID: loginData?.intCompanyID,
                ProcessID: cancelData?.ProcessID,
                UserID: loginData?.intUserID,
                Reason: remarks
            }
            cancelApi(body)
        }
    }
    const cancelApi = (body) => {
        if(cancelData!==null){
            dispatch(getKgKmRateFileUploadCancel(body)).then((res) => {
                if (res.status === 'Success') {
                    setMsg(`Kg - Km Rate Matrix Upload For The File\n${cancelData?.FileName}\nCancelled Successfully`)
                    setIsSuccess(true)
                    getUploadTblData()
                } else {
                    dispatch(updateAlertError("Sorry!, Could Not Cancel The Upload File Request"))
                }
            }).catch((err) => {
                dispatch(updateAlertError(err))

            })
        }
    }
    return (
        <Modal
            headTxt={headText || 'Cancel File Upload'}
            width={'400px'}
            height={'auto'}
            updateModal={updateModal}
            closeId={'closeButton'}
            modalStyle={modalStyle}
        >
            <div style={{ position: 'relative', height: 'calc(100% - 53px)' }}>
                <Typography sx={{ padding: '12px 15px 4px 15px', fontSize: '16px', fontWeight: '600', color: '#444' }}>
                    Reason for the Cancellation of the Kg-Km Rate
                </Typography>
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                    <div className="input--wrapper">
                        <LineinputV2
                            name="value"
                            type="text"
                            label='Remarks'
                            value={remarks}
                            maxLength={150}
                            onBlur={(e) => {
                                setRemarks(e.target.value)
                            }}
                        />
                    </div>
                </Box>
                <Divider />
                <Box sx={{ padding: '4px 15px 4px 15px', display: 'flex', gap: '16px', justifyContent: 'end' }}>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="outlined"
                            onKeyDown={(e) => { }}
                            id={'cityPairSearch_btn'}
                            sx={{ width: '50px', height: "40px", paddingY: '6px !important' }}
                            className="btn cancel-btn"
                            onClick={() => {updateModal(false) }}
                        >
                            Cancel
                        </Button>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => { }}
                            id={'search_btn'}
                            sx={{ width: '40px', height: "40px", paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={() => {
                                handleSave()
                            }}
                        >
                            Save
                        </Button>
                    </Item>
                </Box>

            </div>
        </Modal>
    )
}

export default KgKmCancelPop
